import { IComboBoxOptionStyles, IComboBoxStyles, IProgressIndicatorStyles } from '@fluentui/react';
import { CSSProperties } from 'react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, Sizes } from '../../themes/styles';
import { IStyles } from '../../utils/styles';
import { loaderStylesProgressIndicatorButton } from '../Loader/Loader.styles';

const wideWidth = 500;

export const comboBoxStylesDefault = (theme: IH2OTheme): Partial<IComboBoxStyles> => ({
  root: {
    height: Sizes.height,
    border: `1px solid ${theme.semanticColors?.inputBorder}`,
    borderColor: theme.semanticColors?.inputBorder,
    borderRadius: Sizes.borderRadius,
    lineHeight: Sizes.height - 2, // border * 2
    paddingLeft: Sizes.padding - 1, // border * 1
    color: theme.semanticColors?.inputReadOnlyText,
    overflow: 'hidden',
    '::after': {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: theme.semanticColors?.inputListItemHoveredBackground,
    },
    '&:hover .ms-ComboBox-Input': {
      backgroundColor: theme.semanticColors?.inputListItemHoveredBackground,
    },
    'button:hover': {
      backgroundColor: theme.semanticColors?.inputListItemHoveredBackground,
    },
  },
  rootHovered: {
    backgroundColor: theme.semanticColors?.inputListItemHoveredBackground,
  },
  rootFocused: {
    borderColor: theme.semanticColors?.inputActiveBorder,
  },
  rootDisabled: {
    color: theme.semanticColors?.textDisabled,
    backgroundColor: theme.semanticColors?.inputDisabledBackground,
    pointerEvents: 'none',
    '.ms-Button-icon': {
      color: theme.semanticColors?.textDisabled,
    },
  },
  input: {
    '&:hover': {
      backgroundColor: theme.semanticColors?.inputListItemHoveredBackground,
    },
  },
  optionsContainer: {
    '.ms-ComboBox-option': {
      height: Sizes.height,
      minHeight: Sizes.height,
      lineHeight: Sizes.height,
      'label:hover': {
        '.ms-Checkbox-checkbox': {
          backgroundColor: 'transparent',
        },
      },
    },
    '.ms-Checkbox-checkbox': {
      height: '16px',
      width: '16px',
    },
  },
  label: {
    color: theme.semanticColors?.inputReadOnlyText,
    fontSize: FontSizes.input,
    fontWeight: 'normal',
  },
});

export const comboBoxStylesDefaultWidth: Partial<IComboBoxStyles> = {
  root: {
    width: Sizes.buttonWidth,
  },
  callout: {
    width: Sizes.buttonWidth,
  },
};

export const comboBoxStylesWide: Partial<IComboBoxStyles> = {
  root: {
    width: wideWidth,
  },
  callout: {
    width: wideWidth,
  },
};
export const comboBoxOptionStylesDefault: Partial<IComboBoxOptionStyles> = {
  optionText: {
    overflow: 'visible',
    whiteSpace: 'normal',
  },
};

export const comboboxWithFooterStyles = (theme: IH2OTheme, hideMenu = false): Partial<IComboBoxStyles> => ({
  ...comboBoxStylesDefault(theme),

  callout: {
    display: hideMenu ? 'none' : 'flex',
    '.ms-Callout-main': { overflow: 'visible' },
  },
  optionsContainerWrapper: {
    overflow: 'auto',
    maxHeight: 300,
    '.ms-Button--command.is-checked': {
      backgroundColor: theme.palette?.primary400,
    },
  },
});

export const comboboxLoader = (theme: IH2OTheme): Partial<IProgressIndicatorStyles> => {
  const loaderStyles = loaderStylesProgressIndicatorButton(theme);

  return {
    ...loaderStyles,
    root: {
      ...(loaderStyles.root as IStyles<'root'>),
      position: 'relative',
      height: 1,
      marginTop: -5,
    },
    progressTrack: {
      ...(loaderStyles.root as IStyles<'progressTrack'>),
      backgroundColor: 'transparent',
    },
  };
};

export const comboboxOptionText = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  minWidth: 0,
  maxWidth: '100%',
  display: 'inline-block',
} as CSSProperties;
